// Mapbox requires the wordmark and © credits absent a signed removal order, which we do not hold
// (STX1-881), and the OpenStreetMap half is ODbL-mandated regardless: hiding it is not an option the
// code offers. A leaf module so the chrome insets can read this height without a component.
export const ATTRIBUTION_BADGE_HEIGHT = 26

export const CHROME_INSET_PX = 10

// What the credits row occupies, and so the floor for anything resting above it. Overlays that sit
// outside the element MapControls publishes --map-attribution-top on read this number instead.
export const ATTRIBUTION_TOP_PX = CHROME_INSET_PX + ATTRIBUTION_BADGE_HEIGHT
